import React from "react";
import { useTranslation } from "react-i18next"; 
import ReactApexChart from "react-apexcharts";
import { Paper, Typography } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { formatCurrency } from "../../hooks/Currency";

const TopTenItems = ({ products }) => {
  const { t } = useTranslation();
  const _store = useSelector((state) => state.pos.defStore);

  const [prods, setProds] = useState([]);
  useEffect(() => {
    setProds(
      [...products]
        .sort(
          (f, s) =>
            s
              .map((j) => j.qty * (j.product.sellPrice - j.product.purchPrice))
              .reduce((x, y) => x + y, 0) -
            f
              .map((j) => j.qty * (j.product.sellPrice - j.product.purchPrice))
              .reduce((x, y) => x + y, 0)
        )
        .slice(0, 10)
    );
  }, [products]);

  const options = {
    chart: {
      type: "bar",
      height: 350,
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => formatCurrency(val, _store),
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: prods.map((j) => j[0]?.product?.name || ""),
      labels: {
        formatter: (val) => formatCurrency(val, _store),
        style: {
          fontSize: "14px",
        },
      },
    },
    colors: ["#00E396"],
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: (val) => formatCurrency(val, _store),
      },
    },
  };

  const series = [
    {
      name: t("profit"),
      data: prods.map((group) =>
        group.reduce(
          (sum, item) =>
            sum +
            Number(item.qty || 0) *
              (Number(item.product?.sellPrice || 0) -
                Number(item.product?.purchPrice || 0)),
          0
        )
      ),
    },
  ];

  return (
    <Paper className="shadow-xs p-15 br-6">
      {/* Chart */}
      <Typography variant="h6" className="fs-18 fw-5 gray-color">
        {t("top10ProfitItems")}
      </Typography>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        width="100%"
        height="300"
      />
    </Paper>
  );
};

export default TopTenItems;
